










import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action} from 'vuex-class'

@Component({
  components: {},
})
export default class Confirm extends Vue {
  @Action('closePopup') public closePopup: any

  @Prop({default: '/img/success.svg'}) private image!: string
  @Prop({default: '-CODE-'}) private code!: string
  @Prop({default: '-TITLE-'}) private title!: string
  @Prop({default: '-SUBTITLE-'}) private subtitle!: string
}
